import styled, {css} from 'styled-components/native';
import theme from '../../global/styles/theme';

interface ContainerProps {
  type: string;
  appTheme: 'light' | 'dark';
}

export const Container = styled.View<ContainerProps>`
  padding: 23px;
  flex-direction: row;
  align-items: center;
  width: 90%;
  border-radius: 25px;
  ${props =>
    props.type === 'success'
      ? css`
          background-color: ${theme.colors(props.appTheme).green[700]};
        `
      : css`
          background-color: ${theme.colors(props.appTheme).red[500]};
        `}
`;

export const Icon = styled.Image`
  margin-right: 19px;
`;

export const Text = styled.Text<ContainerProps>`
  ${props =>
    props.type === 'success'
      ? css`
          color: ${theme.colors(props.appTheme).black[700]};
        `
      : css`
          color: ${theme.colors(props.appTheme).white};
        `}
`;
